import { Pipe, PipeTransform } from '@angular/core';
import { Router, UrlCreationOptions } from '@angular/router';

@Pipe({
    name: 'createUrlTree',
    standalone: false
})
export class CreateUrlTreePipe implements PipeTransform {
    constructor(private router: Router) {}
    transform(commands: readonly any[], navigationExtras?: UrlCreationOptions): unknown {
        return this.router.createUrlTree(commands, navigationExtras);
    }
}
